// src/SplashScreen.js
import logo from './logo.png'; // usa tu logo dorado o animado

export default function SplashScreen() {
  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center z-50">
      <img
        src={logo}
        alt="Logo Encuentros VIP"
        className="h-24 w-24 animate-pulse transition duration-700 ease-in-out"
      />
    </div>
  );
}
